/// <amd-module name="CodeCoverage/AllTab/Helpers" />
import { PathConstants } from "CodeCoverage/ViewCommon/Constants";
/**
 * Gets the fileName from the path
 * - Return "" if the path is undefined
 * Example: input /a/b/c or \a\b\c  output: c
 *          input /a     or /a      output: a
 *          input a                 output: a
 */
export function getFileName(path: string | undefined): string {
    if (!path) {
        return "";
    }

    let pathSeparatorIndex = findPathSeparator(path);
    if (pathSeparatorIndex >= 0) {
        return path.substring(pathSeparatorIndex + 1);
    }

    return path;
}

/**
 * Gets a list with all the parent full paths of a provided path in the correct order.
 * @param path The path
 * @returns A list with parent paths, excluding the provided one.
 * @example ("/a/b/c") returns ["/", "/a", "/a/b"]
 */
export function getParentPaths(path: string): string[] {
    const partials: string[] = [];

    if (path.trim()) {
        let previous = path;
        let parent = getFolderName(previous);
        while (previous !== parent && parent != "") {
            partials.push(parent);
            previous = parent;
            parent = getFolderName(previous);
        }
    }

    return partials.reverse();
}

export function findPathSeparator(path: string | undefined): number {
    if (path) {
        let pathSeparatorIndex = path.lastIndexOf(PathConstants.PathSeparator);
        if (pathSeparatorIndex === -1) {
            pathSeparatorIndex = path.lastIndexOf(PathConstants.AltPathSeparator);
        }

        return pathSeparatorIndex;
    }
    return -1;
}

/**
 * Gets the containing directory of the last path component.
 * @param path The path
 * @returns Path characters up to the last slash.
 *          The trailing slash is included if the result is the root directory ("/" or "").
 *          Otherwise, the trailing slash is not included.
 *          Empty string if the path contains no slash.
 */
function getFolderName(path: string): string {
    let pos: number;
    let folder: string;

    if (path) {
        pos = findPathSeparator(path);
        if (pos >= 0) {
            folder = path.substr(0, pos);
            if (folder === "") {
                return PathConstants.RootPath;
            }

            return folder;
        }
    }

    return "";
}
